import React, { Component, PropTypes } from 'react';
import ThemeTableRow from './TableRow';

const TableRows = ({ onClick, list, editConfigRow, deleteConfigRow, single, isDisabled, columns }) => {
    return (
        <tbody>
            {list.map((theme, index) => {
                return (
                    <ThemeTableRow
                        item={theme}
                        key={index}
                        isDisabled={isDisabled}
                        index={index}
                        editConfigRow={editConfigRow}
                        deleteConfigRow={deleteConfigRow}
                        single={single}
                        columns={columns}
                    />
                );
            })}
        </tbody>
    );
};

TableRows.propTypes = {
    content: PropTypes.array
};

export default TableRows;



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/TableRows.js